import { useEffect, useState } from "react";

import ThreadCard from "./ThreadCard";

import { getRecentThreads } from "./apiService";

const RECENT_THREADS_KEY = "thread2blog__recentThreads";
const CACHE_EXPIRATION_MINS = 1;

function oneWeekAgo() {
  const res = new Date();
  res.setDate(res.getDate() - 7);
  return res;
}

function RecentThreads(props) {
  const [recentThreads, setRecentThreads] = useState([]);

  async function onLoad() {
    const cache = JSON.parse(localStorage.getItem(RECENT_THREADS_KEY));
    if (cache) {
      setRecentThreads(cache.threads);
    }

    const now = new Date();
    const minutesSinceLastCache = cache
      ? (now.getTime() - new Date(cache.cachedAt).getTime()) / 1000 / 60
      : 0;

    if (!cache || minutesSinceLastCache > CACHE_EXPIRATION_MINS) {
      const since = oneWeekAgo();
      const res = await getRecentThreads(since);
      const cache = {
        cachedAt: new Date(),
        threads: res,
      };

      localStorage.setItem(RECENT_THREADS_KEY, JSON.stringify(cache));
      setRecentThreads(res);
    }
  }

  useEffect(() => {
    onLoad();
  }, []);

  return (
    <div className="w-full px-0 md:px-8">
      <div className="flex flex-wrap -mx-1 overflow-hidden sm:-mx-1 md:-mx-1 lg:-mx-px xl:-mx-px">
        {recentThreads.map((thread) => (
          <div
            key={thread._id}
            className="my-1 px-1 w-full overflow-hidden sm:my-1 sm:px-1 sm:w-1/2 md:my-1 md:px-1 md:w-1/3 lg:my-px lg:px-px lg:w-1/4 xl:my-px xl:px-px xl:w-1/5 transform transition duration-250 hover:scale-105"
          >
            <ThreadCard thread={thread} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default RecentThreads;
